import { render, staticRenderFns } from "./ContactsDatesBlock.vue?vue&type=template&id=589e3928&lang=pug&"
import script from "./ContactsDatesBlock.vue?vue&type=script&lang=js&"
export * from "./ContactsDatesBlock.vue?vue&type=script&lang=js&"
import style0 from "./ContactsDatesBlock.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports